import React from "react";
import { DEFAULT_FONT_FAMILY } from "../../../config/fontConfig";
import Button from "../../ui/buttons";
import { ReactComponent as Image } from "../../../assets/icons/svg/Home/beta popup/Beta_version_popup_image.svg";
import { ReactComponent as NoCollaboaratorIcon } from "../../../assets/icons/svg/Home/beta popup/No_collaborators.svg";
import { ReactComponent as ExactlySayIcon } from "../../../assets/icons/svg/Home/beta popup/exactly_say.svg";
import { ReactComponent as NoConfusionIcon } from "../../../assets/icons/svg/Home/beta popup/no_confusion.svg";
import { ReactComponent as ShareIcon } from "../../../assets/icons/svg/Home/beta popup/share.svg";
import { ReactComponent as WebApplicationIcon } from "../../../assets/icons/svg/Home/beta popup/web_application.svg";

interface BetaVersionPopupProps {
  onDismiss: () => void;
}

const BetaVersionPopup: React.FC<BetaVersionPopupProps> = ({ onDismiss }) => {
  const handleDismiss = () => {
    onDismiss();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        fontFamily: DEFAULT_FONT_FAMILY,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: 16,
          padding: "60px 0px 60px 40px",
          maxWidth: 900,
          width: "90%",
          display: "flex",
          gap: 60,
          alignItems: "center",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
          overflow: "hidden",
        }}
      >
        {/* Left content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <span
            style={{
              display: "inline-block",
              backgroundColor: "#E5F4FF",
              color: "#00346D",
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 999,
              border: "0.5px solid #BCE5FF",
              padding: "3px 12px",
              marginBottom: 20,
            }}
          >
            Beta version
          </span>
          <h2
            style={{
              fontSize: 26,
              fontWeight: 700,
              color: "#111827",
              lineHeight: 1.20,
              marginBottom: 36,
            }}
          >
            Capture feedback on your website &<br />
            <span style={{ color: "#49AFFF" }}>share it clearly</span> in seconds.
          </h2>

          <div style={{ fontSize: 13, color: "#5A6572", marginBottom: 12 }}>
            Here's what you get now:
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 18, marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
              <WebApplicationIcon style={{ flexShrink: 0, width: 36, height: 36 }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#192028" }}>
                  Web application only
                </div>
                <div style={{ fontSize: 13, color: "#82909D" }}>
                  No mobile or figma designs yet
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
              <NoCollaboaratorIcon style={{ flexShrink: 0, width: 36, height: 36 }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#192028" }}>
                  No collaborators
                </div>
                <div style={{ fontSize: 13, color: "#82909D" }}>
                  Share 1-on-1 only, team features coming soon
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              color: "#5A6572",
              flexWrap: "wrap",
              marginBottom: 32,
              fontFamily: DEFAULT_FONT_FAMILY,
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <NoConfusionIcon /> No more confusion
            </span>
            <span>|</span>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <ExactlySayIcon /> Say exactly what you mean
            </span>
            <span>|</span>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <ShareIcon /> Share via a simple link
            </span>
          </div>

          <Button variant="primary" size="lg" onClick={handleDismiss}>
            Got it!
          </Button>
        </div>

        {/* Right image */}
        <Image style={{ flexShrink: 0, alignSelf: "stretch", display: "block" }} />
      </div>
    </div>
  );
};

export default BetaVersionPopup;
